module.exports = __webpack_public_path__ + "img/icon-paper-coklat.59510cf8.svg";